import React from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import BacklogMetaAPIConsumerWithRelay from './agg-backlog-data';
import BacklogMetaPlanDataAPIConsumer from './rest-backlog-data';
import BacklogMetaAPIConsumer from './swag-backlog-data';

type Props = {
	isCompanyManaged: boolean;
};

const BacklogMetaAPIConsumerWrapper = ({ isCompanyManaged }: Props) => {
	if (isCompanyManaged) {
		return <BacklogMetaPlanDataAPIConsumer />;
	}
	if (ff('jsw.perf.critical-backlog-with-relay')) {
		return <BacklogMetaAPIConsumerWithRelay />;
	}
	return <BacklogMetaAPIConsumer />;
};

export default BacklogMetaAPIConsumerWrapper;
